<template>
  <Section>
    <template v-slot:section-header>
      <h5 class="title" v-if="isProgram">รูปปก/โลโก</h5>
      <h5 class="title" v-else>รูปปก</h5>
    </template>
    <template v-slot:section-body>
      <form>
        <div class="row logo-container" v-if="isProgram">
          <div class="col-md-3 mb-3">
            <ImageField
              :disabled="disabledEdit"
              @update:image="(newImage) => $emit('update:image', { ...item, logoImageCustom: newImage})"
              :title="item.programType === 'program' ? 'โลโกรายการ' : 'โลโกซีซั่น'"
              aspectRatio="1:1"
              imageViewSize="cover640w640h"
              hintText="ขนาดภาพที่เหมาะสม 720 x 720"
              uploadTitle="เลือกรูปโลโก (1:1)"
              emptyMessageText="ไม่มีโลโก"
              imageType="logoImage"
              :image.sync="item.logoImageCustom"
              :defaultImage.sync="item.logoImage" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <ImageField
              :disabled="disabledEdit"
              @update:image="(newImage) => $emit('update:image', { ...item, coverImageCustom: newImage})"
              title="รูปปก (16:9)"
              uploadTitle="เลือกรูปปก (16:9)"
              :image="item.coverImageCustom"
              :defaultImage="item.coverImage" />
          </div>
          <div class="col-md-6 mb-3">
            <ImageField
              :disabled="disabledEdit"
              @update:image="(newImage) => $emit('update:image', { ...item, socialImageCustom: newImage})"
              title="รูปปกโซเชียล"
              uploadTitle="เลือกรูปปกโซเชียล"
              :image.sync="item.socialImageCustom"
              :defaultImage.sync="item.socialImage" />
          </div>
          <div class="col-md-3 mb-3">
            <ImageField
              :disabled="disabledEdit"
              @update:image="(newImage) => $emit('update:image', { ...item, squareImageCustom: newImage})"
              title="รูปปก (1:1)"
              aspectRatio="1:1"
              imageViewSize="cover640w640h"
              hintText="ขนาดภาพที่เหมาะสม 640x640"
              uploadTitle="เลือกรูปปก (1:1)"
              :image.sync="item.squareImageCustom"
              :defaultImage.sync="item.squareImage" />
          </div>
          <div class="col-md-3 mb-3">
            <ImageField
              :disabled="disabledEdit"
              @update:image="(newImage) => $emit('update:image', { ...item, verticalImageCustom: newImage})"
              title="รูปปก (9:16)"
              aspectRatio="9:16"
              imageViewSize="cover720w1280h"
              hintText="ขนาดภาพที่เหมาะสม 720x1280"
              uploadTitle="เลือกรูปปก (16:9)"
              :image.sync="item.verticalImageCustom"
              :defaultImage="item.verticalImage" />
          </div>
        </div>
      </form>
    </template>
  </Section>
</template>

<script>
import Section from '@/components/Section.vue';
import ImageField from './ImageField.vue';

export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isProgram: {
      type: Boolean,
      default: false,
    },
    disabledEdit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Section,
    ImageField,
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.logo-container {
  margin-bottom: $spacer * 3;
}
</style>
